/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

const Shadow: React.FC<any> = ({ handleClose, show }): JSX.Element => {
  const handleClick = (event: React.MouseEvent | React.TouchEvent) => {
    if (event.type === 'touchmove' || event.type === 'swipe') return;
    handleClose();
  };
  return <div onClick={handleClick}>{show ? <div className="shadow shadow-active" style={{ zIndex: 5000 }} /> : null}</div>;
};

export default Shadow;
